
import React from 'react';
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { useUserReport } from '@/hooks/useUserReport';

const PricingRecommendations = () => {
  const { data: report } = useUserReport();

  return (
    <section className="w-full py-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <h2 className="font-bold text-4xl text-[#1F2937] mb-6">
          Your Recommendations
        </h2>
        
        <div className="w-full">
          <div className="bg-white shadow-sm rounded-xl p-6">
            <div className="p-4 bg-[#ECFDF5] border border-[#D1FAE5] shadow-lg rounded-lg">
              <div className="flex items-center justify-center gap-4 mb-6">
                <div className="flex flex-col items-center">
                  <h4 className="text-xl font-semibold text-[#047857]">{report?.tariff_best || 'Best Available Tariff'}</h4>
                </div>
              </div>
              
              <div className="bg-white border border-[#D1FAE5] rounded-lg p-4 mb-6">
                <Table>
                  <TableBody>
                    <TableRow className="border-b border-[#D1FAE5]">
                      <TableCell className="text-[#6B7280]">Annual Gas Savings</TableCell>
                      <TableCell className="text-right font-bold text-lg text-[#059669]">£{report?.tariff_gas_sav?.toLocaleString() || '0'}</TableCell>
                    </TableRow>
                    <TableRow className="border-b border-[#D1FAE5]">
                      <TableCell className="text-[#6B7280]">Annual Electricity Savings</TableCell>
                      <TableCell className="text-right font-bold text-lg text-[#059669]">£{report?.tariff_elec_sav?.toLocaleString() || '0'}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="text-[#6B7280]">Total Annual Savings</TableCell>
                      <TableCell className="text-right font-bold text-lg text-[#059669]">£{report?.tarif_ann_sav?.toLocaleString() || '0'}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
              
              <div className="flex justify-center">
                <Button 
                  className="w-full max-w-[448px] bg-[#059669] hover:bg-[#047857] text-white font-semibold"
                  onClick={() => report?.tariff_link ? window.open(report.tariff_link, '_blank') : null}
                >
                  Switch to {report?.tariff_best || 'Recommended'} Tariff
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingRecommendations;
